import { render, staticRenderFns } from "./type_1.vue?vue&type=template&id=f038f54a&scoped=true"
import script from "./type_1.vue?vue&type=script&lang=js"
export * from "./type_1.vue?vue&type=script&lang=js"
import style0 from "./type_1.vue?vue&type=style&index=0&id=f038f54a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f038f54a",
  null
  
)

export default component.exports